/* eslint-disable @next/next/no-img-element */
import { Icon } from '@iconify/react';

const SectionTwo = () => {
  const benefits = [
    {
      icon: 'https://storage.googleapis.com/xooply-assets/cp/zoom/benefits/easy-to-use.png',
      desc: 'Mudah Digunakan',
    },
    {
      icon: 'https://storage.googleapis.com/xooply-assets/cp/zoom/benefits/safe-and-secure.png',
      desc: 'Aman & Terpercaya',
    },
    {
      icon: 'https://storage.googleapis.com/xooply-assets/cp/zoom/benefits/flexibility.png',
      desc: 'Fleksibilitas',
    },
    {
      icon: 'https://storage.googleapis.com/xooply-assets/cp/zoom/benefits/best-price.png',
      desc: 'Harga Terbaik',
    },
    {
      icon: 'https://storage.googleapis.com/xooply-assets/cp/zoom/benefits/budget-efficiency.png',
      desc: 'Efisiensi Anggaran',
    },
  ];

  return (
    <section className="bg-white">
      <div className="section-container !py-10 flex flex-col lg:flex-row lg:items-center gap-[30px]">
        <div className="flex flex-col gap-2.5 lg:w-1/2">
          <h2 className="text-lg lg:text-2xl font-[600]">
            Kenapa harus langganan ZOOM di Xooply.ID?
          </h2>

          <p className="text-sm text-justify">
            Layanan produk Zoom di Xooply dirancang untuk memberikan kemudahan dan efisiensi bagi
            kebutuhan operasional Anda. Belanja melalui Xooply memastikan Anda mendapatkan penawaran
            terbaik, proses pembelian yang mudah, serta dukungan pelanggan yang responsif.
          </p>
        </div>

        <div className="lg:w-1/2 flex flex-col gap-[15px]">
          <div className="flex flex-col min-[564px]:flex-row items-center justify-center gap-[15px]">
            {benefits.slice(0, 2).map((item, index) => (
              <div
                key={index}
                className="bg-[#295BF6] rounded-[10px] p-2.5 flex gap-2.5 items-center"
              >
                <img alt={item.desc} src={item.icon} className="w-[40px]" />

                <h3 className="text-[13px] font-medium text-white">{item.desc}</h3>
              </div>
            ))}
          </div>

          <div className="flex flex-col min-[564px]:flex-row items-center justify-center gap-[15px]">
            {benefits.slice(2).map((item, index) => (
              <div
                key={index}
                className="bg-[#295BF6] rounded-[10px] p-2.5 flex gap-2.5 items-center"
              >
                <img alt={item.desc} src={item.icon} className="w-[40px]" />

                <h3 className="text-[13px] font-medium text-white">{item.desc}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionTwo;
